/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { useToast } from '../ui/use-toast';
import { Loader2 } from 'lucide-react';
import { hubUsersActions } from '../../actions/hubUsers.action';
import { HubUser } from '../../types/hubUsers/hubUsers';

const HubUsersManagement = () => {
  const [users, setUsers] = useState<HubUser[]>([]);
  const [loading, setLoading] = useState(true);
  const { toast } = useToast();

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const res = await hubUsersActions.getHubUsers();
      setUsers(res.data || []);
    } catch (e) {
      toast({ title: 'Error', description: 'Failed to fetch hub users', variant: 'destructive' });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold">Hub Users</h1>
        <span className="text-sm text-muted-foreground">
          {users.length} registered {users.length === 1 ? 'user' : 'users'}
        </span>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Community Hub registrations</CardTitle>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Name</TableHead>
                <TableHead>Email</TableHead>
                <TableHead>Role</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Joined</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {users.map((u) => {
                const inactive = u.isActive === false;
                return (
                  <TableRow key={u._id}>
                    <TableCell className="font-medium">
                      {[u.firstName, u.lastName].filter(Boolean).join(' ') || '—'}
                    </TableCell>
                    <TableCell>{u.email}</TableCell>
                    <TableCell className="uppercase">{u.role}</TableCell>
                    <TableCell>
                      <span
                        className={`px-2 py-0.5 text-xs rounded ${
                          inactive ? 'bg-gray-300 text-gray-700' : 'bg-green-200 text-green-800'
                        }`}
                      >
                        {inactive ? 'Inactive' : 'Active'}
                      </span>
                    </TableCell>
                    <TableCell>
                      {u.createdAt ? new Date(u.createdAt).toLocaleDateString() : '—'}
                    </TableCell>
                  </TableRow>
                );
              })}
              {users.length === 0 && (
                <TableRow>
                  <TableCell colSpan={5} className="text-center text-muted-foreground py-6">
                    No hub users yet.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
};

export default HubUsersManagement;
